import { useMutation } from 'react-query';
import { useContext } from 'react';
import LoadingContext from './LoadingProvider';

const useGlobalMutation = (mutationFn, options = {}) => {
    const { setIsLoading } = useContext(LoadingContext);

    const wrappedMutationFn = async (data) => {
        if (typeof data !== 'object' || data === null) {
            return mutationFn(data);
        }
        if (options.clean === false) {
            return mutationFn(data);
        }

        const payload = Object.fromEntries(
            Object.entries(data).filter(([_, v]) => v != null && v !== '')
        );

        return mutationFn(payload);
    };

    return useMutation(wrappedMutationFn, {
        ...options,
        onMutate: (...args) => {
            setIsLoading(true);
            options.onMutate?.(...args);
        },
        onSettled: (...args) => {
            setIsLoading(false);
            options.onSettled?.(...args);
        }
    });
};

export default useGlobalMutation;
